var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from 'vue';
import './MtHeaderInner.css';
export default Vue.extend({
    functional: true,
    name: 'MtHeaderInner',
    render: function (h, context) {
        return h('div', { class: 'mt-header__inner' }, [
            // считаем количество детей
            // и добавляем каждому ширину в зависимости от их количества
            context.children
                .filter(function (_a) {
                var tag = _a.tag;
                return tag != null;
            })
                .map(function (child, _i, arr) {
                child.data = child.data || {};
                child.data.style = __assign(__assign({}, child.data.style), { width: 100 / arr.length + "%" });
                return child;
            }),
        ]);
    },
});
//# sourceMappingURL=MtHeaderInner.js.map